import { InputProps, InputRef } from 'antd';
import { forwardRef } from 'react';
import { FieldError } from 'react-hook-form';
import { AppAdminFormLabel } from '@components/atoms';
import SearchTextField from '@components/atoms/SearchTextField';

interface SearchTextFieldWithLabelProps extends InputProps {
  label: string;
  required?: boolean;
  className?: string;
  placeholder?: string;
  error?: FieldError;
}

const SearchTextFieldWithLabel = forwardRef<InputRef, SearchTextFieldWithLabelProps>(
  ({ required, label, className, placeholder, error, ...restProps }, ref) => {
    return (
      <div className={className}>
        <AppAdminFormLabel required={required} label={label} />
        <SearchTextField
          ref={ref}
          placeholder={placeholder}
          {...restProps}
          status={error ? 'error' : undefined}
        />
        <div className="h-6 mt-1">
          {error && <p className="text-red-500 text-sm">{error.message}</p>}
        </div>
      </div>
    );
  }
);

SearchTextFieldWithLabel.displayName = 'SearchTextFieldWithLabel';

export default SearchTextFieldWithLabel;
